<template>
  <div class="apo">
    <div class="aa">
      <div class="title">兑换码</div>
      <van-form @submit="onSubmit">
        <van-field
          v-model="value"
          name="用户名"
          class="input"
          autocomplete="on"
          placeholder="请输入兑换码"
        ></van-field>

        <div style="margin: 0 20px">
          <van-button
            block
            type="info"
            native-type="submit"
            style="width: 100%; height: 42px; border-radius: 4px"
          >
            确认兑换
          </van-button>
        </div>
      </van-form>
      <div class="bottom">兑换前请核对兑换码</div>
    </div>
    <div class="aas">
      <van-swipe style="width: 100%" :autoplay="3000">
        <van-swipe-item
          v-for="(image, index) in images"
          :key="index"
          @click="clicks(image.imgUrl)"
        >
          <img style="width: 100%" :src="image.imgAddress" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <van-dialog
      v-model="show"
      confirmButtonText="好的，我知道了"
      confirmButtonColor="#3491fa"
      title="兑换成功"
    >
      <div style="font-size: 14px; margin-bottom: 10px">
        兑换码：
        <span v-if="shows == true">{{ cdk }}</span>
        <span v-else>请稍微{{ num }}秒，系统加载中</span>
        <span
          v-if="shows == true"
          style="margin-left: 10px; color: #3491fa"
          @click="copy(cdk)"
        >
          复制
        </span>
      </div>
      <van-swipe style="width: 100%" :autoplay="5000">
        <van-swipe-item
          v-for="(image, index) in images"
          :key="index"
          @click="clicks(image.imgUrl)"
        >
          <img style="width: 100%" :src="image.imgAddress" />
        </van-swipe-item>
      </van-swipe>
    </van-dialog>
  </div>
</template>

<script>
  import { useRedeemCode, redeemCodeSettingsModel } from "@/api/cardOperation";

  export default {
    data() {
      return {
        show: false,
        num: 5,
        shows: false,
        value: "",
        cdk: "",
        images: [
          {
            id: 1,
            imgUrl: "",
            imgAddress: "https://img01.yzcdn.cn/vant/apple-1.jpg",
          },
          {
            id: 2,
            imgUrl: "",
            imgAddress: "https://img01.yzcdn.cn/vant/apple-2.jpg",
          },
        ],
      };
    },
    created() {},
    async mounted() {
      await this.redeemCodeSettingsModel();
    },
    methods: {
      copy(val) {
        //val复制的值
        // console.log(val);
        let input = document.createElement("input");
        input.value = val;
        input.id = "creatDoms";
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        this.$toast("复制成功");
        // ===========================
      },
      clicks(val) {
        if (val.length > 0) {
          window.location.href = val;
        }
      },
      redeemCodeSettingsModel() {
        redeemCodeSettingsModel().then((res) => {
          document.title = res.data.systemName;
          if (res.data.redeemCodeCarouselModelList.length > 0) {
            this.images = res.data.redeemCodeCarouselModelList;
          }
        });
      },
      onSubmit() {
        useRedeemCode(this.value).then((res) => {
          this.cdk = res.data.cdk;
          this.num = 5;
          const getPhoneInterval = setInterval(() => {
            this.num--;
            if (this.num <= 0) {
              clearInterval(getPhoneInterval);
              this.shows = true;
            }
          }, 1000);
          this.show = true;
          this.shows = false;
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .apo {
    background: url("../../assets/bcg.jpg") no-repeat;
    background-size: 100%;
    width: 100%;
    height: 100vh;
    padding-top: 169px;
    box-sizing: border-box;
  }

  .aa {
    width: 335px;
    height: 257px;
    border-radius: 10px;
    background: white;
    box-sizing: border-box;
    padding-top: 20px;
    margin: 0 20px;
    box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.3);
  }

  .aas {
    width: 335px;
    border-radius: 10px;
    background: white;
    box-sizing: border-box;
    padding-top: 20px;
    margin: 40px 20px;
    box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.3);
  }

  .title {
    font-size: 14px;
    text-align: left;
    margin: 20px 20px;
  }

  .input {
    border-radius: 5px;
    width: 295px;
    padding: 10px;
    margin: 30px 20px;
    height: 42px;
    border: 1px solid #e2e2e2;
  }

  .bottom {
    font-size: 14px;
    margin: 20px 10px;
  }
</style>
